/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */
export const THIRD_PARTY_OAUTH_SUCCESS_EVENT = 'link-picker-third-party-experiment-auth-success';

const broadcastThirdPartyOauthSuccess = () => {
	window.dispatchEvent(new CustomEvent(THIRD_PARTY_OAUTH_SUCCESS_EVENT));
};

export const triggerThirdPartyAuthFlow = (startUrl: string): Promise<void> => {
	return new Promise((resolve, reject) => {
		let authWindow: Window | null = null;
		let authWindowInterval: number;

		const handleAuthWindowClosed = () => {
			if (authWindow && authWindow.closed) {
				finishAuthFlow();
				reject(new Error('The auth window was closed when authorizing through link picker.'));
			}
		};

		const initiateAuthFlow = () => {
			window.addEventListener('message', handleAuthWindowMessage);
			authWindow = window.open(startUrl, startUrl);
			authWindowInterval = window.setInterval(handleAuthWindowClosed, 500);
		};

		const finishAuthFlow = () => {
			clearInterval(authWindowInterval);
			window.removeEventListener('message', handleAuthWindowMessage);
			if (authWindow) {
				authWindow.close();
				authWindow = null;
			}
		};

		const handleAuthWindowMessage = (event: MessageEvent) => {
			if (event.source !== authWindow) {
				return;
			}
			const { data } = event;
			if (typeof data !== 'object') {
				return;
			}

			switch (data.type) {
				case 'outbound-auth:success':
					broadcastThirdPartyOauthSuccess();
					finishAuthFlow();
					resolve();
					break;

				case 'outbound-auth:failure':
					finishAuthFlow();
					reject(new Error(data.message));
					break;
			}
		};

		initiateAuthFlow();
	});
};
